import { RefObject, useRef } from 'react';
import { CancelIcon, Tooltip, TOOLTIP_SURFACE } from '@repo/atomic-components';

export interface StopResponseButtonProps {
  onStop: () => void;
  /** Icon size in px. */
  size?: number;
}

export const StopResponseButton = ({ onStop, size = 32 }: StopResponseButtonProps) => {
  const buttonRef = useRef<HTMLSpanElement>(null);

  return (
    <>
      <span ref={buttonRef} className="inline-flex">
        <button
          type="button"
          onClick={onStop}
          aria-label="Stop"
          className="focus-visible:ring-theme-dark-green flex cursor-pointer items-center justify-center rounded-md focus-visible:ring-2 focus-visible:outline-none"
        >
          <CancelIcon width={size} height={size} aria-hidden="true" />
        </button>
      </span>
      <Tooltip
        target={buttonRef as RefObject<HTMLElement>}
        content="Stop"
        position="top"
        className={TOOLTIP_SURFACE}
        baseZIndex={10000}
      />
    </>
  );
};
